class ImageWithText extends HTMLElement {
	constructor() {
		super();

		this.uniqueClass = `.image-with-text--${this.dataset.id}`;
		this.image = `${this.uniqueClass} .image-with-text__image-wrapper`;
		this.firstSubheading = `${this.uniqueClass} .image-with-text__text-container-subheading`;
		this.innerContainer = `${this.uniqueClass} .image-with-text__text-container-inner`;
		if (this.dataset.changePosition === 'true' && window.innerWidth < 720) {
			this.init();
		}
	}

	init() {
		document
			.querySelector(this.innerContainer)
			.insertBefore(document.querySelector(this.image), document.querySelectorAll(this.firstSubheading)[1]);
	}
}
customElements.define('image-with-text', ImageWithText);
